import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import type { ListFieldElement } from '../../../../types/form/Element';
import { useFormSubmitterContext } from '../../form-submitter-context';
import { ACTION_LIST_FIELD_ON_CHANGE } from '../../form-submitter-context/form-submitter-constant';
import RequiredMark from '../../../../common/components/required-mark';
import ListFieldSubmitter from './list-field-submitter';

type Props = {
  description?: Node;
  element: ListFieldElement;
};

const ListFieldWithContext = (props: Props) => {
  const { element, description } = props;
  const { id, disabled, type, required, label, options = [] } = element;
  const {
    state,
    dispatch,
    selector: { getSelectedValuesForId, getErrorForId },
  } = useFormSubmitterContext();

  const error = getErrorForId(state, id);
  const values = getSelectedValuesForId(state, id);
  const { submitInProgress } = state;
  const isDisabled = submitInProgress;

  const onChange = React.useCallback(
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7006
    newValues => {
      dispatch({
        id,
        type: ACTION_LIST_FIELD_ON_CHANGE,
        newValues,
      });
    },
    [dispatch, id],
  );

  const renderLabel = required ? (
    <>
      {label} <RequiredMark />
    </>
  ) : (
    label
  );

  return (
    <ListFieldSubmitter
      // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
      description={description}
      error={error && <FormattedMessage {...error} />}
      fieldType={type}
      isDisabled={disabled || isDisabled}
      isRequired={required}
      label={renderLabel}
      onChange={onChange}
      options={options}
      selectedValues={values}
    />
  );
};

export { ListFieldWithContext };
export default ListFieldWithContext;
